var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    d: "M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16ZM24.0606 9.93934C23.4749 9.35355 22.5251 9.35355 21.9393 9.93934C21.9252 9.95349 21.9119 9.96847 21.8995 9.98421L14.9548 18.8335L10.7678 14.6464C10.182 14.0607 9.23222 14.0607 8.64643 14.6464C8.06065 15.2322 8.06065 16.182 8.64643 16.7678L13.9393 22.0607C14.5251 22.6464 15.4749 22.6464 16.0606 22.0607C16.0737 22.0476 16.086 22.0339 16.0975 22.0195L24.0819 12.0389C24.6463 11.4516 24.6392 10.5179 24.0606 9.93934Z",
    fill: "#211551"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract);
export default __webpack_public_path__ + "static/media/Subtract.91d69cd2f23767b99e75e86ecd0c1f6e.svg";
export { ForwardRef as ReactComponent };